import { Directive, ElementRef, Renderer2, Output, Input, EventEmitter, OnInit, OnDestroy, HostBinding } from '@angular/core';

@Directive({
  selector: '[unhStickyItem]'
})
export class StickyItemDirective implements OnInit, OnDestroy {
  private destroyScrolListener: () => void;
  private destroyResizeListener: () => void;

  @Output() behaviorChanged = new EventEmitter<boolean>();
  @Input() offset = 0;

  @HostBinding('class.unh-sticky-item') stickyItem = true;
  @HostBinding('class.stuck') stuck = false;

  @HostBinding('style.position') positionSticky = 'sticky';
  @HostBinding('style.top')  get offsetTop() { return this.offset + 'px'; }

  constructor(private elRef: ElementRef, private r2: Renderer2) {}

  ngOnInit() {
    this.destroyScrolListener = this.r2.listen('window', 'scroll', evt => this.onScroll(evt));
    this.destroyResizeListener = this.r2.listen('window', 'resize', evt => this.onScroll(evt));
  }

  onScroll(evt: Event) {
    const hostEl: HTMLElement = this.elRef.nativeElement;
    const distance = hostEl.getBoundingClientRect().top;

    if (distance === this.offset) {
        if (!this.stuck) {
            this.behaviorChanged.emit(this.stuck);
            this.stuck = true;
        }
    } else {
        if (this.stuck) {
            this.behaviorChanged.emit(this.stuck);
            this.stuck = false;
        }
    }
  }

  ngOnDestroy() {
    this.destroyScrolListener();
    this.destroyResizeListener();
  }
}
